import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseFormMobileComponent } from '../../../base-components';
import { InputCountItemsRendererComponent } from '../../../general-components/ag-grid/components/cell-renderers';
import { removeCharacters } from '@foxeet/utils/*';

@Component({
  selector: 'ui-mobile-form-input-text',
  templateUrl: './form-input-text.component.html',
  styleUrls: ['./form-input-text.component.scss'],
})
export class FormInputTextComponent extends BaseFormMobileComponent<string> implements OnInit {
  @Input() matchControlName: string;
  @Input() showButton: boolean;
  @Input() buttonIcon: string;
  @Input() buttonCallback: any;
  @Input() buttonColor: any;
  @Input() callback: (arg) => void;
  @Output() blurEmitter = new EventEmitter();

  public matchControl: FormControl;

  blur($event: Event) {
    this.control.updateValueAndValidity();
    this.blurEmitter.emit($event);
  }



    /**
     * Detecta cuando se pega texto (CTRL+V) en el textarea
     * @param event Evento de pegado
     */
    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent): void {
      // Prevenir el comportamiento predeterminado del navegador
      event.preventDefault();

      const input = event.target as HTMLInputElement;

      const clipboardData = event.clipboardData;
      const pastedText = clipboardData?.getData('text') ?? '';
      const cleanedText = removeCharacters(pastedText);

      const start = input.selectionStart ?? undefined;
      const end = input.selectionEnd ?? undefined;

      const originalValue = input.value;
      const newValue = originalValue.slice(0, start) + cleanedText + originalValue.slice(end);

      input.value = newValue;
      this.control.setValue(newValue);

      const newPos = start + cleanedText.length;
      input.setSelectionRange(newPos, newPos);
    }

    /** **** */
}
